import { render, staticRenderFns } from "./gzhuizong.vue?vue&type=template&id=63decb30&scoped=true&"
import script from "./gzhuizong.vue?vue&type=script&lang=js&"
export * from "./gzhuizong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63decb30",
  null
  
)

export default component.exports